import React, { useState, useEffect, useContext } from 'react';
import { Grid2, MenuItem } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { billTypes } from '../../Configurations/ExpenseEntryConfig';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';
import { ValidationModeContext } from '../../../contexts/VendorPaymentValidationModeContext';
import ValidationModeEnum from './ValidationMode.enum';
import { ExpenseModeEnum } from './ExpenseMode.enum';
import ExpenseClassEnum from './ExpenseClass.enum';
import { BillTypeEnum } from './BillType.enum';

const ExpenseBillType = (props) => {
    const {
        index,
        expense,
        isClinicianReimbursement,
        mode,
        isSGA,
        isPosted,
        isPendingSubmission,
        isViewOnly,
        isVault,
    } = props;
    const { control, errors, setValue } = useFormContext();
    const validationMode = useContext(ValidationModeContext);
    const [required, setRequired] = useState({ required: true });

    useEffect(() => {
        setRequired({
            required:
                expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
                expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                (mode !== ExpenseModeEnum.CreditCard ||
                    expense?.status === ExpenseStatusValuesEnum.Approved),
        });
    }, [expense?.status]);

    const getBillTypeOptions = () => {
        if (isClinicianReimbursement) {
            return billTypes.filter(
                (type) => type.value !== 'ClinicianDeduction' && type.value !== BillTypeEnum.SGA
            );
        }

        if (isSGA[index]) {
            return billTypes.filter(
                (type) =>
                    type.value === 'NonBillTeam' ||
                    type.value === 'NonBillProducer' ||
                    type.value === BillTypeEnum.SGA
            );
        }

        if (isVault) {
            return billTypes.filter(
                (type) => type.value === 'Billable' || type.value === 'NonBillProducer'
            );
        }

        if (expense?.expenseClass !== ExpenseClassEnum.IngestedCCTransaction) {
            return billTypes.filter((type) => type.value !== 'SGA');
        }

        return billTypes;
    };

    const clearCategoryAndType = () => {
        if (expense?.expenseClass === ExpenseClassEnum.Payment) {
            setValue(`expenseEntries[${index}].category`, '');
            setValue(`expenseEntries[${index}].type`, '');
            setValue(`expenseEntries[${index}].bookingType`, '');
        }
    };

    return (
        <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].billType`}
                defaultValue={!expense.billType ? '' : expense.billType}
                rules={{
                    required:
                        required.required &&
                        !(
                            mode === ExpenseModeEnum.Vault &&
                            validationMode === ValidationModeEnum.Save
                        )
                            ? 'Bill type is required'
                            : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        id="bill-type"
                        select
                        onChange={(e) => {
                            if (isSGA[index]) {
                                setValue(`expenseEntries[${index}].sgaBillType`, e.target.value);
                            } else {
                                setValue(
                                    `expenseEntries[${index}].bookingBillType`,
                                    e.target.value
                                );
                            }
                            onChange(e);
                            clearCategoryAndType();
                        }}
                        value={!value ? '' : value}
                        label="Bill type"
                        {...required}
                        disabled={
                            isViewOnly ||
                            (isPosted && isViewOnly) ||
                            (isPendingSubmission && mode !== ExpenseModeEnum.Payment)
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.billType)}
                        helperText={errors.expenseEntries?.[index]?.billType?.message}
                    >
                        <MenuItem value="" disabled>
                            Select a bill type
                        </MenuItem>
                        {getBillTypeOptions().map((option, index) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                id={`bill-type-menu-option-${index}`}
                            >
                                {option.type}
                            </MenuItem>
                        ))}
                    </ExpenseTextField>
                )}
            />
        </Grid2>
    );
};

export default ExpenseBillType;
